import React from "react";

const Policy = () => {
    return <div>poli</div>
};
export default Policy;